// extracted by mini-css-extract-plugin
module.exports = {"customercare":"customercare-module--customercare--2nnjg","title":"customercare-module--title--3jErt"};